import { Component, HostBinding } from '@angular/core';
import { PortRequestFormServiceService } from 'src/app/shared/service/port-request-FormService/port-request-form.service.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-pc-fleet',
  templateUrl: './pc-fleet.component.html',
  styleUrls: ['./pc-fleet.component.scss'],
})
export class PcFleetComponent {
  username: any;
  elements: any;
  filteredData: any;
  itemsPerPage: number = 100;
  currentPage: number = 0;
  paginatedData: any;
  subusername: any;
  constructor(
    private requestFormService: RequestFormService,
    private prequestFormService: PortRequestFormServiceService,
  ) {}
  ngOnInit() {
    this.loadData();
        this.subusername = localStorage.getItem('loginPic') ?? '';
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  @HostBinding('class.pc-fleet--light') get fleetLight(): boolean {
    return !this.isDarkMode();
  }

  get tooltipClass(): string {
    return this.isDarkMode()
      ? 'preformatted-tooltip'
      : 'preformatted-tooltip preformatted-tooltip--light';
  }
  loadData() {
    this.username = localStorage.getItem('username');
    this.prequestFormService.getFleetViewData('true').subscribe((data) => {
      const clientFilters: { [key: string]: (item: any) => boolean } = {
        'Eiger Shipping': (item) =>
          item.client &&
          (item.client === 'Northwell' ||
            item.client.toLowerCase() === 'eiger'),
        'Zeronorth ZN': (item) =>
          item.client && item.client.toLowerCase() === 'zeronorth',
        'Elite Shipping': (item) =>
          item.client &&
          (item.client === 'elite tankship dmcc' ||
            item.client.toLowerCase() === 'elite'),
        'Bunge Shipping': (item) =>
          item.client && item.client.toLowerCase() === 'bunge',
        'Alcor Shipping': (item) =>
          item.client &&
          (item.client.toLowerCase() === 'alcor chartering dmcc' ||
            item.client.toLowerCase() === 'alcor chartering'),
        'EMZoil Shipping': (item) =>
          item.client && (item.client.toLowerCase() === 'emz oil' || item.client.toLowerCase() === 'emzoil fzco'),
        'Ethiopian Shipping & Logistics': (item) => item.client.toLowerCase() === 'ethiopian shipping & logistics',
      };
      if (this.username === 'Meraki - Operations') {
        data = data.data;
      } else if (clientFilters[this.username]) {
        data = data.data.filter(clientFilters[this.username]);
      }
      // Hide Hanna vessel for Grace user
      if (this.subusername?.toLowerCase() === 'grace') {
        data = data.filter(
          (item: any) => String(item.vessel_imo ?? item.imo ?? item.imo_number) !== '9397456'
        );
      }
      this.elements = data;
      this.paginateData();
    });
  }
  paginateData() {
    const source =
      this.filteredData && this.filteredData.length > 0
        ? this.filteredData
        : this.elements;

    const startIndex = this.currentPage * this.itemsPerPage;

    this.paginatedData = source.slice(
      startIndex,
      startIndex + this.itemsPerPage,
    );
  }

  getWarrantedStyle(element: any): { [klass: string]: any } {
    const total = element.performance_against_warranties;
    const isDark = this.isDarkMode();
    return {
      color:
        total < 0
          ? isDark
            ? '#ff9090'
            : '#dc2626'
          : total > 0
            ? isDark
              ? '#a8d296'
              : '#16a34a'
            : isDark
              ? 'inherit'
              : '#64748b',
      fontWeight: total !== 0 ? '600' : '400',
    };
  }
  getTotalDesignStyle(element: any) {
    const total = element.performance_against_design;
    const isDark = this.isDarkMode();

    return {
      color:
        total < 0
          ? isDark
            ? '#ff9090'
            : '#dc2626'
          : total > 0
            ? isDark
              ? '#a8d296'
              : '#16a34a'
            : isDark
              ? 'inherit'
              : '#64748b',
      fontWeight: total !== 0 ? '600' : '400',
    };
  }

  getWarrantedTooltip(element: any): string {
    return (
      `Maneuvering: ${
        element.maneuvering_performance_against_warranties_mt?.toFixed(2) ||
        '0.00'
      }\n` +
      `Idle: ${
        element.idle_performance_against_warranties_mt?.toFixed(2) || '0.00'
      }\n` +
      `Cargo Ops: ${
        element.cargo_ops_performance_against_warranties_mt?.toFixed(2) ||
        '0.00'
      }`
    );
  }

  getDesignTooltip(element: any): string {
    return (
      `Maneuvering: ${
        element.maneuvering_performance_against_design_mt?.toFixed(2) || '0.00'
      }\n` +
      `Idle: ${
        element.idle_performance_against_design_mt?.toFixed(2) || '0.00'
      }\n` +
      `Cargo Ops: ${
        element.cargo_ops_performance_against_design_mt?.toFixed(2) || '0.00'
      }`
    );
  }
  formatVesselName(name: string): string {
    if (!name) return '';

    return name
      .toLowerCase()
      .split(' ')
      .filter((word) => word.trim().length > 0)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  private segmentColorMap: { [key: string]: string } = {
    mr: '#c27036',
    handymax: '#369047',
    suezmax: '#6a6a6a',
    vlcc: '#3249d4',
    aframax: '#7e3b3b',
    'gas tanker': '#5b5418',
    handy: '#35707b',
    lr1: '#2a644f',
    lr2: '#556ba6',
    coaster: '#859914ff',
    handysize: '#541e85',
    supramax: '#6b181f',
    ultramax: '#85501c',
    panamax: '#723768',
    kamsarmax: '#077c5f',
    'ultra panamax': '',
    capesize: '#7c7440',
    chinamax: '',
    'lr1/panamax': '#42bfaaff',
    'lr2/aframax': '#427ebf',
    'lr3/suezmax': '#bf4281ff',
  };

  getDynamicSegmentStyle(segment: string): any {
    if (!segment) return {};

    const key = segment.toLowerCase();

    // If NOT in static mapping → assign dynamic color
    if (!this.segmentColorMap[key]) {
      this.segmentColorMap[key] = this.generateDarkColorFromText(key);
    }

    const color = this.segmentColorMap[key];

    return {
      'background-color': color,
      'border-radius': '12px',
      padding: '0px 6px',
      color: '#fff',
      display: 'inline-block',
      'font-weight': '500',
      'text-transform': 'uppercase',
      'font-size': '12px',
      'letter-spacing': '0.5px',
    };
  }

  /** Generates a consistent dark color for unknown segments */
  private generateDarkColorFromText(text: string): string {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    let r = (hash >> 16) & 0xff;
    let g = (hash >> 8) & 0xff;
    let b = hash & 0xff;

    // Force dark tones
    r = Math.floor(r * 0.4);
    g = Math.floor(g * 0.4);
    b = Math.floor(b * 0.4);

    return `rgb(${r}, ${g}, ${b})`;
  }
  formatSegment(value: string): string {
    if (!value) return '';

    const trimmed = value.trim().toLowerCase().replace(/\s+/g, ' ');
    const match = trimmed.match(/^([a-z0-9]+)\s*(\(([^)]+)\))?$/i);

    if (match) {
      const main = match[1].toUpperCase(); // e.g., 'LR1', 'MR'
      const bracket = match[3]
        ? ` (${match[3].charAt(0).toUpperCase()}${match[3].slice(1)})`
        : '';
      return main + bracket;
    }

    // Fallback: title case
    return value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
  }
}
